import { FC } from 'react';
import { IconStyled } from './style';

interface IconProps {
  finishScreenImage?: string;
  children?: React.ReactNode;
}

const Icon: FC<IconProps> = ({ children, finishScreenImage, ...restProps }) => (
  <IconStyled src={finishScreenImage} {...restProps}>
    {children}
  </IconStyled>
);

export default Icon;
